import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-log").then((r) => setLogs(r.data)); }, []);
  return (
    <div data-testid="audit-log-page">
      <div className="label-uppercase">Tracciabilità</div>
      <h1 className="font-serif text-4xl mt-2 mb-8">Audit log</h1>
      <table className="admin-table w-full bg-white border border-[#E6E4E0]">
        <thead><tr><th>Data/ora</th><th>Utente</th><th>Azione</th><th>Entità</th><th>Dettagli</th></tr></thead>
        <tbody>
          {logs.map((l) => (
            <tr key={l.id}>
              <td className="whitespace-nowrap text-xs">{new Date(l.timestamp).toLocaleString("it-IT")}</td>
              <td className="text-xs">{l.user_email}</td>
              <td className="text-xs font-medium">{l.action}</td>
              <td className="text-xs">{l.entity} <span className="text-[#5C5657]">{l.entity_id?.slice(0,8)}</span></td>
              <td className="text-xs text-[#5C5657]">{Object.keys(l.details||{}).length ? JSON.stringify(l.details) : "—"}</td>
            </tr>
          ))}
          {logs.length === 0 && <tr><td colSpan="5" className="text-center py-8 text-[#5C5657]">Nessuna attività</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
